import React, { ReactNode, useState } from 'react';
import { AccordionContextType } from './Accordion.types';

export const AccordionContext =
  React.createContext<AccordionContextType | null>(null);

export const AccordionProvider = ({
  children,
  initialOpen = false,
}: {
  children: ReactNode;
  initialOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen);
  const handleToggle = () => setIsOpen((prev) => !prev);

  return (
    <AccordionContext.Provider value={{ isOpen, handleToggle }}>
      {children}
    </AccordionContext.Provider>
  );
};
